// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zA49","colBig":"styles_colBig__21LLS","colSmall":"styles_colSmall__3zEA9"};